import getEditorData from '../../Common/getEditorData';
import saveEditorData from '../../Common/saveEditorData';
import router from '../../../router/routes';
import destroyEditorData from '../../Common/destroyEditorData';

export default {
    namespaced: true,

    state: {
        sectionId: '',
        name: '',
        order: 0,
        postData: [],
        published: false,
        route: '',
        steps: [],
        step: '',
        deleteModal: false,
        cards: [],
        level: 'basic'
    },

    getters: {
        postData(state) {
            return {
                step_id: state.step,
                name: state.name,
                order: state.order,
                published: state.published,
                level: state.level,
            };
        },

        publishedText(state) {
            if (state.published) {
                return 'Published';
            } else {
                return 'Not Published';
            }
        },

        route(state) {
            if (state.sectionId) {
                return '/api/section/edit/' + state.sectionId;
            } else {
                return '/api/section/create';
            }
        }
    },

    mutations: {
        setSectionId(state, value) {
            state.sectionId = value;
        },

        setLevel(state, value) {
            state.level = value;
        },

        setName(state, value) {
            state.name = value;
        },

        setOrder(state, value) {
            state.order = value;
        },

        setPublished(state, value) {
            state.published = value;
        },

        setStep(state, value) {
            state.step = value;
        },

        setSteps(state, value) {
            state.steps = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        },

        setCards(state, value) {
            state.cards = value;
        }
    },

    actions: {
        getData({ commit, getters, state }) {
            commit('overlay/toggle', true, { root: true });
            commit('setSectionId', router.currentRoute.params.id ? router.currentRoute.params.id : 0);

            getEditorData(getters.route).then((response) => {
                commit('setSteps', response.data.data.steps);
                const section = response.data.data.section;
                if (state.sectionId) {
                    commit('setName', section.name);
                    commit('setOrder', section.order);
                    commit('setPublished', section.published);
                    commit('setStep', section.step.id);
                    commit('setCards', section.cards);
                    commit('setLevel', section.level);
                } else {
                    // Make sure we don't return previous creation data.
                    // If you remove this, and someone who has previously created a card
                    // returns to the creation form, the previous card's data will still be there.
                    commit('setName', '');
                    commit('setOrder', 0);
                    commit('setPublished', 0);
                    commit('setStep', null);
                    commit('setCards', []);
                    commit('setLevel', 'basic');
                }

                commit('overlay/toggle', false, { root: true });
            });
        },

        saveData({ getters, commit, dispatch }) {
            saveEditorData('section', getters.route, getters.postData)
                .then((sectionId) => {
                    if (router.currentRoute.name === 'SectionEdit') {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                commit('overlay/toggle', false, { root: true });
                            });
                    } else {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                router.push('/section/edit/' + sectionId);
                            });
                    }
                })
                .catch(() => {});
        },

        destroyData({ state, dispatch }) {
            destroyEditorData('/api/section/delete/' + state.sectionId)
                .then(() => {
                    dispatch('sidebar/getSidebar', '', { root: true });
                })
                .catch(() => {});
        },
    },
};
